
















































































import axios from 'axios'
import { Component } from 'vue-property-decorator'
import VueBase, {Validate} from '@/pages/vue-base'
import User, {IUser} from '@/models/User'
import BasicForm from '@/components/entry/BasicForm.vue'
import ChangeJobForm from '@/components/entry/ChangeJobForm.vue'
import EntryLayout from '@/components/entry/Layout.vue'
import {
  apiV1UsersCurrentPath,
  apiV1UsersEmailPath,
  apiV1UsersPasswordPath,
  apiV1UsersPath,
  apiV1UsersSignOutPath
} from '@/rails/routes'

@Component({
  components: {
    EntryLayout,
    BasicForm,
    ChangeJobForm
  }
})
export default class SettingsIndex extends VueBase {
  user = new User()
  current_password = ''
  new_password = ''
  new_password_confirmation = ''
  valid_email = true

  get emailRules(): Validate[] {
    return [(v: string) => /.+@.+/.test(v) || 'Emailを入力してください']
  }

  set emailRules(value: Validate[]) {}

  async mounted(): Promise<void> {
    const res = await axios.get<IUser>(apiV1UsersCurrentPath())
    this.user = new User(res.data)
  }

  async changePassword(): Promise<void> {
    try {
      await axios.put(apiV1UsersPasswordPath(), {
        current_password: this.current_password,
        new_password: this.new_password,
        new_password_confirmation: this.new_password_confirmation
      })
      this.current_password = ''
      this.new_password = ''
      this.new_password_confirmation = ''
      await this.reloadUser()
      this.showMessage('パスワードの変更が完了しました')
    } catch (e) {
      this.showError(JSON.parse(e.request.response).join(','))
    }
  }

  async saveAgentService(): Promise<void> {
    try {
      await axios.put(apiV1UsersPath(), {
        user: { agent_service: this.user.agent_service }
      })
      await this.reloadUser()
      this.showMessage('設定の変更が完了しました')
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
    }
  }

  async saveReceiveEZine(): Promise<void> {
    try {
      await axios.put(apiV1UsersPath(), {
        user: { receive_e_zine: this.user.receive_e_zine }
      })
      await this.reloadUser()
      this.showMessage('設定の変更が完了しました')
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
    }
  }

  async saveEmail(): Promise<void> {
    if (!(this.$refs.form as HTMLFormElement).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }
    try {
      await axios.put(apiV1UsersEmailPath(), {
        user: { unconfirmed_email: this.user.unconfirmed_email }
      })
      await this.reloadUser()
      this.showMessage('新しいメールアドレス宛に確認メールが送信されました、認証を行ってください。')
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
    }
  }

  async logout(): Promise<void> {
    const res = await axios.delete(apiV1UsersSignOutPath())
    if (res.status === 200) {
      window.location.href = this.settings.site.top
    } else {
      this.showError('ログアウトに失敗しました')
    }
  }

  async reloadUser(): Promise<void> {
    try {
      const res = await axios.get<IUser>(apiV1UsersCurrentPath())
      this.$store.dispatch('setUser', new User(res.data))
    } catch {
      window.location.href = '/users/sign_in'
    }
  }
}
